import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const House = ({ height = '24px', fill = '#282828', width = '24px', ...rest }) => {
    return (_jsx(BaseIcon, { viewBox: '0 0 24 24', height, width, ...rest, children: _jsx("path", { fill: fill, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 5L5 11V19H8V14H11V19H19V11L12 5Z' }) }));
};
//# sourceMappingURL=House.js.map